import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  certcontrol: any;
  certificado: any;
}

// tipagem do que o hook retorna
type ICertificadoReponse = IResponseData;

async function getCertificado(UUID: string): Promise<ICertificadoReponse> {
  const response = await backend.get<IResponseData>(`/certificado/${UUID}`);
  return response.data;
}

export function useCertificado(UUID: string) {
  return useQuery(['certificado', UUID], () => getCertificado(UUID), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
  });
}
